if (!Object.entries) {
    Object.entries = function(O) {
        return [].reduce.call(Object.keys(O), (e, k) => [].concat.call(e, typeof k === 'string' && {}.propertyIsEnumerable.call(O, k) ? [[k, O[k]]] : []), []);
    }
}
